import { gql, useLazyQuery } from '@apollo/client';
import {AnyObject} from "../../models/types";

export interface GetDiagnosticDumpsVars {
  domainId: string;
}

interface DiagnosticDumpsResponse {
  getDiagnosticDumps: string[];
}

const GET_DIAGNOSTIC_DUMPS = gql`
    query GetDiagnosticDumps($domainId: String!) {
        getDiagnosticDumps(domainId: $domainId)
    }
`;

export const useGetDiagnosticDumps = () => {
  return useLazyQuery<AnyObject, GetDiagnosticDumpsVars>(GET_DIAGNOSTIC_DUMPS, {
    errorPolicy: 'all',
    fetchPolicy: 'no-cache'
  });
};